import auth from '../authentication';
import Vue from '../main';

export default {
    getOwner(context, data, callback) {
        Vue.http.post(Vue.apiUrl + '/owner/get-all', data)
            .then(response => {
                context.error = false;
                context.owners = response.data.data;
                context.total = response.data.total;
                context.message = response.data.message;
                callback(context);
            })
            .catch(response => {
                context.error = true;
                context.message = response.data.message;
                context.total = 0;
                callback(context);
            })
    },
    getOwnerSelect(context, callback) {
        Vue.http.post(Vue.apiUrl + '/owner/get-select')
            .then(response => {
                context.error = false;
                context.owners = response.data.data;
                callback(context);
            })
            .catch(response => {
                context.error = true;
                context.message = response.data.message;
                callback(context);
            })
    },
    getOwnerDetail(context, id, callback) {
        Vue.http.post(Vue.apiUrl + '/owner/get-detail/' + id)
            .then(response => {
                context.error = false;
                context.owner = response.data.data;
                callback(context);
            })
            .catch(response => {
                context.error = true;
                context.message = response.data.message;
                callback(context);
            })
    },
    createOwner(context, data, callback) {
        Vue.http.post(Vue.apiUrl + '/owner/add-new', data)
            .then(response => {
                context.error = false;
                context.success = true;
                context.owner = response.data.data;
                callback(context);
            })
            .catch(response => {
                context.error = true;
                context.success = false;
                context.message = response.data.message;
                callback(context);
            })
    },
    updateOwner(context, id, data, callback) {
        Vue.http.post(Vue.apiUrl + '/owner/update-detail/' + id, data)
            .then(response => {
                context.error = false;
                context.success = true;
                context.owner = response.data.data;
                callback(context);
            })
            .catch(response => {
                context.error = true;
                context.success = false;
                context.message = response.data.message;
                callback(context);
            })
    },
    removeOwner(context, id, callback) {
        Vue.http.post(Vue.apiUrl + '/owner/remove/' + id, {})
            .then(response => {
                context.error = false;
                context.success = true;
                callback(context);
            })
            .catch(response => {
                context.error = true;
                context.success = false;
                callback(context);
            })
    }
};